<template>
    <div class="logout">
        <div class="logout-wrapper">
            <a href="#" @click="onLogout()"> <icon class="logout-icon" icon="power-off"/> {{ $t('header.logout') }}</a>
        </div>
    </div>
</template>

<script>

import Icon from '@/components/atoms/Icon'

export default {
    name: 'Logout',
    components: {
        Icon
    },
    methods: {
        onLogout () {
            window.oidc.userManager.signoutRedirect()
        }
    }
}
</script>

<style lang="scss">
.logout {
    display: flex;
    align-items: center;

    .logout-wrapper {
        border-left: 1px solid $font;
        line-height: 1rem;

        a {
            color: #6e6e6e;
            display: flex;
            align-items: center;
            transition: opacity 0.3s;

            &:hover {
                opacity: 0.5;
                text-decoration: none;
            }

            .logout-icon {
                margin-right: 10px !important;
            }
        }
    }
}
</style>
